import FeedManagement from "./feed-management.page";

export default FeedManagement;
